<template>
    <div class="rp-user-login">
        <div class="rp-user-login__header">
            <MessengerPageHeader
                class="rp-messenger-header"
                @onBackButtonClick="onBackButtonClick"
                :messengerStyle="{}"
                :listHeader="'loginScreen.title'"
            />
            <RPBreadCrumb
                @breadCrumbClick="handleBreadCrumbClick"
                :breadCrumbHandler="breadCrumbHandler"
                :isItFullScreen="isItFullScreen"
            />
        </div>
        <div class="rp-user-login__body">
           <transition
                name="basic-card-transition"
                :enter-active-class="routeEnterAnimation"
                :leave-active-class="routeLeaveAnimation"
                :duration="{}"
            >
                <LoginFormVue
                    v-if="currentRouteId === LOGIN_FORM_ROUTE_ID"
                    @sendCode="sendCode"
                    @loginSuccess="loginSuccess"
                    :header="currentRouteName"
                    :payload="currentRoutePayload"
                />
                <CodeFormVue
                    v-else-if="currentRouteId === CODE_FORM_ROUTE_ID"
                    @clicked-on-change="changeUserLoginId"
                    :payload="currentRoutePayload"
                    @loginSuccess="loginSuccess"
                />
            </transition>
        </div>
        
    </div>
</template>
<script>
import ConversationListHeader from '../ConversationListHeader';
import LoginFormVue from './LoginForm.vue'
import CodeFormVue from './CodeForm.vue';
const LOGIN_FORM_ROUTE_ID = 'LOGIN_FORM';
const CODE_FORM_ROUTE_ID = 'CODE_FORM';
const FORWARD_ANIMATION = {
    routeEnterAnimation: 'animated fast fadeInRight entering',
    routeLeaveAnimation: 'animated fast fadeOutLeft leaving'
}
const BACKWARD_ANIMATION = {
    routeEnterAnimation: 'animated fast fadeInLeft entering',
    routeLeaveAnimation: 'animated fast fadeOutRight leaving'
}
export default {

    props: {
        initialPayload: Object,
        isItFullScreen: Boolean,
    },

    components: {
        LoginFormVue,
        MessengerPageHeader: ConversationListHeader,
        CodeFormVue,
    },

    mounted() {
        this.handleInitialPayload()
    },

    data() {
        return {
            breadCrumbHandler: [ {
                    scenarioId: 'HOME',
                    scenarioName: 'Home',
                },
                {
                    scenarioId: LOGIN_FORM_ROUTE_ID,
                    scenarioName: this.$t('loginScreen.title')
                }
            ],
            CODE_FORM_ROUTE_ID,
            LOGIN_FORM_ROUTE_ID,
            routeEnterAnimation: FORWARD_ANIMATION.routeEnterAnimation,
            routeLeaveAnimation: FORWARD_ANIMATION.routeLeaveAnimation,
        }
    },

    computed: {

        currentRoute() {
            return this.breadCrumbHandler[this.breadCrumbHandler.length-1] || {}
        },

        currentRouteName() {
            return this.currentRoute.scenarioName;
        },

        currentRouteId() {
            return this.currentRoute.scenarioId;
        },

        currentRoutePayload() {
            return this.currentRoute.payload || {}
        }
    },

    methods: {

        handleInitialPayload() {
            const {
                initialPayload
            } = this;

            if(initialPayload.sourcePersonId) {
                this.sendCode(initialPayload)
            }
        },

        sendCode({ userLoginId, userIdType, sourcePersonId, phoneCode }) {
            // Sending OTP
            this.changeRoute({ scenarioId: CODE_FORM_ROUTE_ID, scenarioName: this.$t('loginScreen.enterTheCode'), payload: { userLoginId, userIdType, sourcePersonId, phoneCode } }, FORWARD_ANIMATION)
        },

        onBackButtonClick() {
            if(this.currentRouteId === LOGIN_FORM_ROUTE_ID) {
                this.$emit('onBackButtonClick')
                return;  
            }
            this.handleBreadCrumbClick(this.breadCrumbHandler[this.breadCrumbHandler.length-2]);           
        },

        changeRoute(route, animation) {
            this.breadCrumbHandler.push(route)
            this.routeEnterAnimation = animation.routeEnterAnimation
            this.routeLeaveAnimation = animation.routeLeaveAnimation
        },

        handleBreadCrumbClick(route) {

            const {
				scenarioId,
            } = route;

			if(scenarioId === 'HOME' ) {
				this.$emit('onBackButtonClick')
				this.breadCrumbHandler = [];
				return;
			}
			let currentClickedIndex = this.breadCrumbHandler.findIndex((breadCrumb) => breadCrumb.scenarioId === scenarioId);
			this.breadCrumbHandler = this.breadCrumbHandler.slice(0, currentClickedIndex);
			this.changeRoute(route, BACKWARD_ANIMATION)
        },
        
        changeUserLoginId({ userLoginId }) {
            this.onBackButtonClick();
        },

        loginSuccess({ encryptedData, userProperties }) {
            this.$emit('loginSuccess', { encryptedData, userProperties })
        }
    }
}
</script>
<style lang="scss" scoped>
.rp-user-login {
    .rp-user-login__body {
        padding: 0rem 1rem 1rem;
    }
    .entering {
        animation-delay: 200ms
    }
    .leaving {
        animation-duration: 200ms;
    }
    
}
</style>